import Timer from './Timer';
import Game from '../../../Game';
import DateHelper from '../../../Utility/DateHelper';
import { IGameState } from '../../../State/Game/IGameState';

export default class SeasonPassTimer extends Timer {
    constructor() {
        super();
    }
    public complete() {
        //season pass timer is completed
    }
    public isCompleted(state?: IGameState): boolean {
        return DateHelper.now.getTime() > DateHelper.getDateFromValue(state.playerState.seasonPass.endDate).getTime();
    }
    public getDate(state: IGameState = Game.store.getState()): Date | null {
        return (
            DateHelper.getDateFromValue(state.playerState.seasonPass.startDate) || null
        );
    }
    public getFormattedCountdown(state: IGameState): string {
        const timeRemaining = DateHelper.getDateFromValue(state.playerState.seasonPass.endDate).getTime() - DateHelper.now.getTime();
        return this.formatTime(timeRemaining);
    }

    private formatTime(milliseconds: number): string {
        const seconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        if (days > 0) {
            return `${days} ${days > 1 ? Game.locale.getText('Days') : Game.locale.getText('Day')}`;
        } else if (hours > 0) {
            const remainingMinutes = minutes % 60;
            return `${hours.toString().padStart(2, '0')}${Game.locale.getText('TimerHoursShortform')}:${remainingMinutes.toString().padStart(2, '0')}${Game.locale.getText('TimerMinutesShortform')}`;
        } else {
            const remainingSeconds = seconds % 60;
            return `${minutes.toString().padStart(2, '0')}${Game.locale.getText('TimerMinutesShortform')}:${remainingSeconds.toString().padStart(2, '0')}${Game.locale.getText('TimerSecondsShortform')}`;
        }
    }
}
